module.exports = __webpack_public_path__ + "media/images/arrow-down-fill-3ab6b9d226eddb7faa49080250e62e92.svg";